import React from "react";
import ProjectDetailCard from "../ProjectDetailCard";

import sentiment from "../../../Assets/Projects/NLP/G2g.png";
import sentiment2 from "../../../Assets/Projects/NLP/G2g2.png";
import sentiment3 from "../../../Assets/Projects/NLP/G2g3.png";
import sentiment4 from "../../../Assets/Projects/NLP/G2g4.png";
import sentiment5 from "../../../Assets/Projects/NLP/G2g5.png";

function Glad2GlowSentimentAnalysis() {
  return (
    <ProjectDetailCard
      title="Sentiment Analysis of Glad2Glow Reviews on TikTok Shop"
      image={sentiment}
      screenshots={[sentiment2, sentiment3, sentiment4]}
      description="
      Sentiment Analysis of Glad2Glow Reviews on TikTok Shop is a Natural Language Processing (NLP) project developed to analyze customer opinions based on product reviews collected from TikTok Shop. The project applies text preprocessing techniques and machine learning algorithms to classify reviews into positive, neutral, and negative sentiments. In addition to sentiment classification, the system provides data visualization and analytical insights that help evaluate customer satisfaction, identify common concerns, and support data-driven business decisions for product and marketing improvement.
      "
      technologies={[
        "Python",
        "Scikit-learn",
        "NLTK",
        "Sastrawi",
        "TF-IDF",
        "Pandas",
        "NumPy",
        "Matplotlib",
        "WordCloud",
        "Jupyter",
      ]}
      github="https://github.com/Rezaananda28"
      demo=""
    >
      {/* Project Gallery */}

      <div className="project-section-card mt-4">
        <h3 className="purple">Project Gallery</h3>

        <div className="gallery-grid">
          <img src={sentiment5} alt="gallery1" />
          <img src={sentiment4} alt="gallery2" />
          <img src={sentiment3} alt="gallery3" />
        </div>
      </div>
    </ProjectDetailCard>
  );
}

export default Glad2GlowSentimentAnalysis;
